import { Node as ContentfulNode } from '@contentful/rich-text-types';
import { DocumentWithEmbeddedEntries } from 'libs/contentful/types';
import Media from 'components/shared/Media/Media';

const renderEmbeddedAsset = (
  node: ContentfulNode,
  children: React.ReactNode,
  content: DocumentWithEmbeddedEntries,
  roundedImage = true,
) => {
  const asset = node.data.target;
  const blockAssets = content?.links?.assets?.block || [];
  const foundAsset = blockAssets.find(i => i.sys.id === asset.sys.id);

  if (!foundAsset) return null;

  return (
    <Media
      media={foundAsset}
      data-testid="embeddedAsset"
      roundedImage={roundedImage}
      sizes="(max-width: 800px) 100vw, 800px"
    />
  );
};

export default renderEmbeddedAsset;
